import { PaymentTerm } from '../common';

export interface CustomerPaymentTermsRes {
  paymentTerms: PaymentTerm[];
}
